import React from 'react'

export const FacebookIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clipath="url(#clip0_1_2779)">
                <path d="M18.896 0H1.104C0.494 0 0 0.494 0 1.104V18.897C0 19.506 0.494 20 1.104 20H10.684V12.255H8.076V9.237H10.682V7.01C10.682 4.427 12.26 3.02 14.565 3.02C15.669 3.02 16.617 3.102 16.894 3.139V5.839H15.296C14.042 5.839 13.8 6.436 13.8 7.309V9.237H16.789L16.399 12.255H13.799V20H18.897C19.505 20 19.999 19.506 19.999 18.896V1.104C20 0.494 19.506 0 18.896 0Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_1_2779">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
